<div *ngIf="!isEditMode" class="heading">
  <span i18n="@@S_CREATE_GEOFENCE">Create geofence</span>
</div>
<div *ngIf="isEditMode" class="heading">
  <span i18n="@@S_EDIT_GEOFENCE">Edit geofence</span>
</div>

<fm-tabs class="advanced-options__tabs">
  <fmTab
    id="geofence-details"
    [active]="activeTab === EGeofenceFormTabs.Details"
    i18n-heading="@@S_DETAILS"
    heading="Details"
    a7s-id="geofence-form-details-tab"
  >
    <ng-template fmTabContent>
      <ng-container *ngTemplateOutlet="detailsContent"></ng-container>
    </ng-template>
  </fmTab>
  <fmTab
    id="geofence-advanced-options"
    [active]="activeTab === EGeofenceFormTabs.AdvancedOptions"
    i18n-heading="@@S_ADVANCED_OPTIONS"
    heading="Advanced options"
    a7s-id="geofence-form-advanced-options-tab"
  >
    <ng-template fmTabContent>
      <ng-container *ngTemplateOutlet="advancedOptionsContent"></ng-container>
    </ng-template>
  </fmTab>
</fm-tabs>

<div class="footer-buttons">
  <button mat-button class="btn-uppercase" a7s-id="geofence-form-cancel" i18n="@@S_CANCEL" (click)="onCancelClick()">Cancel</button>
  <button
    *ngIf="!isHotSpot"
    mat-flat-button
    color="accent"
    class="btn-uppercase"
    [disabled]="detailsFormGroup.invalid || advancedOptionsContentFormGroup.invalid"
    a7s-id="geofence-form-save"
    i18n="@@S_SAVE"
    (click)="onSaveClick()"
  >
    Save
  </button>

  <button
    *ngIf="isHotSpot"
    mat-flat-button
    color="accent"
    class="btn-uppercase"
    [disabled]="detailsFormGroup.invalid || advancedOptionsContentFormGroup.invalid"
    a7s-id="geofence-form-save"
    i18n="@@S_ACCEPT"
    (click)="onSaveClick()"
  >
    Accept
  </button>
</div>

<ng-template #detailsContent>
  <div class="tab-content">
    <form novalidate [formGroup]="detailsFormGroup">
      <div class="form-element">
        <mat-form-field class="address-section" floatLabel="always" appearance="outline" color="accent">
          <mat-label i18n="@@S_ADDRESS">Address</mat-label>
          <input
            matInput
            readonly="true"
            formControlName="address"
            i18n-placeholder="@@S_GEOFENCE_ADDRESS_PLACEHOLDER_PROMPT"
            placeholder="Place geofence shape over address"
            a7s-id="geofence-form-address-input"
          />
          <mat-error i18n="@@S_YOU_MUST_ENTER_ADDRESS_BEFORE_SAVING" *ngIf="detailsFormGroup.get('address').hasError('required')">
            You must enter an address before saving it.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-element">
        <mat-form-field class="name-section" floatLabel="always" appearance="outline" color="accent">
          <mat-label i18n="@@S_NAME">Name</mat-label>
          <input
            matInput
            formControlName="name"
            placeholder="Name the geofence"
            a7s-id="geofence-form-name-input"
            i18n-placeholder="@@S_GEOFENCE_NAME_PLACEHOLDER"
          />
          <mat-error
            i18n="@@S_GEOFENCE_NAME_ERROR"
            *ngIf="detailsFormGroup.get('name').hasError('required') || detailsFormGroup.get('name').hasError('whitespace')"
          >
            You must enter a name before saving it.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-element">
        <mat-form-field floatLabel="always" appearance="outline" color="accent" class="mat-form-field__multiline-error">
          <mat-label i18n="@@S_GROUP">Group</mat-label>
          <mat-select
            formControlName="groups"
            placeholder="Choose a geofence group"
            a7s-id="geofence-form-group-dropdown"
            i18n-placeholder="@@S_GEOFENCE_GROUP_PLACEHOLDER"
            multiple
          >
            <vzc-select-all
              [selectedOptions]="detailsFormGroup.get('groups')"
              [options]="hierarchyGroups"
              selectAllLabel="SELECT ALL"
              i18n-selectAllLabel="@@S_ANALYTICS_SELECT_ALL"
              deselectAllLabel="DESELECT ALL"
              i18n-deselectAllLabel="@@S_ANALYTICS_DESELECT_ALL"
            >
            </vzc-select-all>
            <mat-option *ngFor="let group of hierarchyGroups" [value]="group">{{ group.name }}</mat-option>
          </mat-select>
          <mat-error
            class="mandatory-geofence-groups-error"
            i18n="@@S_PLACE_GROUP_NOTVALID"
            *ngIf="detailsFormGroup.get('groups').hasError('invalidMandatoryGroups')"
          >
            You must select a group for this place before saving it
          </mat-error>
        </mat-form-field>
        <span class="form-element-info" i18n="@@S_MANAGE_GEOFENCES_BY_ADDING_THEM_TO_GROUPS"
          >Manage geofences by adding them to groups.</span
        >
      </div>
      <div class="form-element">
        <mat-form-field floatLabel="always" appearance="outline" color="accent">
          <mat-label i18n="@@S_CATEGORY">Category</mat-label>
          <mat-select
            formControlName="category"
            placeholder="UnCategorized"
            a7s-id="geofence-form-category-dropdown"
            i18n-placeholder="@@S_CATEGORY_UNCATEGORIZED"
          >
            <mat-option *ngFor="let placeCategory of placeCategories" [value]="placeCategory.Id">{{
              placeCategory.Description
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <span class="form-element-info" i18n="@@S_FIND_GEOFENCES_QUICKLY">Find geofences quickly by categorizing them.</span>
      </div>
      <div class="form-element">
        <mat-label class="form-element-label" i18n="@@S_DESCRIPTION">Description</mat-label>
        <textarea
          placeholder="Enter a description"
          formControlName="description"
          a7s-id="geofence-form-description-input"
          i18n-placeholder="@@S_GEOFENCE_DESCRIPTION_PLACEHOLDER"
        ></textarea>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #advancedOptionsContent>
  <div class="tab-content">
    <form novalidate [formGroup]="advancedOptionsContentFormGroup">
      <div class="form-element">
        <mat-form-field floatLabel="always" appearance="outline" color="accent">
          <mat-label i18n="@@S_CONTACT_NAME">Contact Name</mat-label>
          <input
            matInput
            formControlName="contactName"
            placeholder="Enter contact name"
            a7s-id="geofence-form-contact-name-input"
            i18n-placeholder="@@S_GEOFENCE_CONTACT_NAME_PLACEHOLDER"
          />
        </mat-form-field>
      </div>
      <div class="form-element">
        <mat-form-field floatLabel="always" appearance="outline" color="accent">
          <mat-label i18n="@@S_CONTACT_PHONE_NUMBER">Contact Phone Number</mat-label>
          <input
            matInput
            formControlName="contactPhoneNumber"
            placeholder="Enter phone number"
            a7s-id="geofence-form-phone-number-input"
            i18n-placeholder="@@S_GEOFENCE_PHONE_NUMBER_PLACEHOLDER"
          />
          <mat-error
            i18n="@@S_PLACE_NUMBER_NOTVALID"
            *ngIf="advancedOptionsContentFormGroup.get('contactPhoneNumber').hasError('invalidPhoneNumber')"
          >
            Please enter a valid contact number
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-element">
        <mat-form-field floatLabel="always" appearance="outline" color="accent">
          <mat-label i18n="@@S_GEOFENCE_ID">Geofence ID</mat-label>
          <input
            matInput
            formControlName="clientID"
            placeholder="Enter geofence ID"
            a7s-id="geofence-form-geofence-id-input"
            i18n-placeholder="@@S_GEOFENCE_GEOFENCE_ID_PLACEHOLDER"
          />
          <mat-error i18n="@@S_PLACE_PLACEID_NOTVALID" *ngIf="advancedOptionsContentFormGroup.get('clientID').hasError('invalidClientId')">
            You must enter a unique Place ID before saving this place.
          </mat-error>
        </mat-form-field>
      </div>

      <span class="checkbox-header" i18n="@@S_SELECT_TO_APPEAR_ON">Select to appear on</span>
      <div class="checkbox-body">
        <mat-checkbox formControlName="showOnMap" color="accent" i18n="@@S_MAP" a7s-id="geofence-form-show-on-map-checkbox" color="primary"
          >Map</mat-checkbox
        >
        <mat-checkbox
          formControlName="showOnAddress"
          color="accent"
          i18n="@@S_ADDRESS"
          a7s-id="geofence-form-show-on-address-checkbox"
          color="primary"
          >Address</mat-checkbox
        >
      </div>
      <div class="article-section">
        <span class="article-section__title" i18n="@@S_HELP_CENTER_ARTICLE">Help Center Article</span>
        <a href="{{ geofenceHelpCenterUrl }}" class="link-with-icon" target="_blank" a7s-id="inline-geofence-help-center-link">
          <span i18n="@@S_LINK_TO_GEOFENCE_HELPCENTER_ARTICLE" class="link-with-icon__text">Learn how to set up geofence alerts</span>
          <mat-icon svgIcon="ic-link" class="mat-icon-size-xs link-with-icon__icon"></mat-icon>
        </a>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #saveModal>
  <div class="save-cancel-modal">
    <span *ngIf="isEditMode" class="save-cancel-modal__title" i18n="@@S_GEOFENCE_UPDATED">Geofence updated</span>
    <span *ngIf="!isEditMode" class="save-cancel-modal__title" i18n="@@S_GEOFENCE_CREATED">Geofence created</span>
    <span class="save-cancel-modal__description" i18n="@@S_GEOFENCE_ON_LIVE_MAP_AND_PLACES"
      >This geofence is now on Live Map and in Places</span
    >
    <div class="save-cancel-modal__buttons">
      <button
        mat-flat-button
        color="accent"
        class="btn-uppercase"
        i18n="@@S_CLOSE"
        a7s-id="geofence-form-save-modal-close"
        (click)="closeSaveModal()"
      >
        CLOSE
      </button>
    </div>
  </div>
</ng-template>

<ng-template #cancelModal>
  <div class="save-cancel-modal">
    <span class="save-cancel-modal__title" i18n="@@S_REVEAL_GEOFENCE_MODAL_TITLE_DISCARD_CHANGES">Discard changes?</span>
    <span class="save-cancel-modal__description" i18n="@@S_REVEAL_GEOFENCE_MODAL_DESCRIPTION_CHANGES_NOT_SAVED"
      >Changes will not be saved.</span
    >
    <div class="save-cancel-modal__buttons">
      <button
        mat-raised-button
        color="tertiary"
        class="btn-uppercase"
        i18n="@@S_REVEAL_BUTTON_CLOSE"
        a7s-id="geofence-form-cancel-modal-abort"
        (click)="closeCancelModal(false)"
      >
        CLOSE
      </button>
      <button
        mat-flat-button
        color="accent"
        class="btn-uppercase"
        i18n="@@S_REVEAL_BUTTON_DISCARD"
        a7s-id="geofence-form-cancel-modal-confirm"
        (click)="closeCancelModal(true)"
      >
        DISCARD
      </button>
    </div>
  </div>
</ng-template>
